.layout {
  display: grid;
  grid-template-columns: minmax(0, 0.92fr) minmax(0, 1.08fr);
  gap: 18px;
  align-items: start;
}

.addColumn,
.playlistColumn {
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-width: 0;
}

.inlineForm {
  display: flex;
  gap: 8px;
  align-items: stretch;
}

.inlineForm input {
  flex: 1;
  min-width: 0;
}

.searchInputWrap {
  position: relative;
  flex: 1;
  min-width: 0;
}

.searchInputWrap input {
  width: 100%;
  padding-right: var(--token-space-3xl);
}

.clearSearchButton {
  position: absolute;
  top: 50%;
  right: var(--token-space-xs);
  transform: translateY(-50%);
  width: var(--token-space-2xl);
  min-height: var(--token-space-2xl);
  border: 0;
  border-radius: var(--token-radius-pill);
  background: color-mix(in srgb, var(--token-text-primary) 8%, transparent);
  color: color-mix(in srgb, var(--token-text-primary) 68%, transparent);
  font-family: var(--token-font-ui);
  font-size: var(--token-fs-sm);
  font-weight: 800;
  line-height: 1;
  cursor: pointer;
}

.clearSearchButton:hover {
  background: color-mix(in srgb, var(--token-text-primary) 14%, transparent);
}

.primaryButton,
.removeButton,
.iconButton {
  min-height: 38px;
  border-radius: 999px;
  border: 1px solid color-mix(in srgb, var(--token-accent) 45%, transparent);
  font-family: var(--token-font-ui);
  font-weight: 700;
  cursor: pointer;
}

.primaryButton {
  padding: 0 18px;
  background: var(--token-accent);
  color: var(--token-card-bg);
}

.removeButton {
  padding: 0 12px;
  background: rgba(176, 58, 46, 0.08);
  color: rgba(176, 58, 46, 0.95);
  border-color: rgba(176, 58, 46, 0.35);
}

.iconButton {
  width: 38px;
  background: rgba(255, 255, 255, 0.68);
  color: var(--token-text-primary);
}

.primaryButton:disabled,
.removeButton:disabled,
.iconButton:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.error {
  margin: 2px 0 0;
  color: rgba(176, 58, 46, 0.95);
  font-family: var(--token-font-ui);
  font-size: 12px;
  line-height: 1.35;
}

.searchResults,
.videoList {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.result,
.videoRow {
  display: grid;
  grid-template-columns: 112px minmax(0, 1fr);
  gap: 10px;
  align-items: center;
  min-width: 0;
  padding: 8px;
  border-radius: 14px;
  border: 1px solid rgba(28, 38, 32, 0.13);
  background: rgba(255, 255, 255, 0.58);
}

.result {
  width: 100%;
  text-align: left;
  cursor: pointer;
}

.videoRow {
  grid-template-columns: 112px minmax(0, 1fr) auto;
}

.thumb,
.thumbFallback {
  width: 112px;
  aspect-ratio: 16 / 9;
  border-radius: 10px;
  object-fit: cover;
  background: rgba(28, 38, 32, 0.1);
}

.thumbFallback {
  display: grid;
  place-items: center;
  font-size: 26px;
  color: var(--token-accent);
}

.resultText,
.videoText {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.resultText strong,
.videoText strong {
  font-family: var(--token-font-ui);
  color: var(--token-text-primary);
  font-size: 13px;
  line-height: 1.25;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.resultText span,
.videoText span {
  font-family: var(--token-font-body);
  color: rgba(28, 38, 32, 0.62);
  font-size: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.rowActions {
  display: flex;
  gap: 5px;
  align-items: center;
}

.empty {
  margin: 0;
  padding: 18px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.5);
  color: rgba(28, 38, 32, 0.68);
  font-family: var(--token-font-body);
}

@media (max-width: 900px) {
  .layout {
    grid-template-columns: 1fr;
  }
}
